import { Overlay } from '@mantine/core'
import React from 'react'

import { StyledCard } from './Card.styles'
import type { ICard } from './Card.types'

export const Card: React.FC<React.PropsWithChildren<ICard>> = ({
  children,
  elevation,
  backgroundColor,
  active = false,
  disabled = false,
  className = 'flectoui--card',
  ...props
}) => {
  return (
    <StyledCard
      backgroundColor={backgroundColor}
      active={active}
      elevation={elevation}
      className={className}
      {...props}
    >
      {disabled && <Overlay radius={8} color='#fff' opacity={0.75} />}

      {children}
    </StyledCard>
  )
}

export default Card
